import { Injectable } from "@angular/core";
import { BehaviorSubject, map } from "rxjs";
import { SessionService } from "../session/session.service";
import {
  IChangePasswordPayload,
  IChangePasswordResponse,
  IForgotPassword_Request,
  IForgotPassword_Response,
  ILoginApiResponse,
  ILoginUser_Request,
  IRegisterUser_Request,
  IResetPassword_Request,
  IResetPassword_Response,
  IUserEntity,
  IUserLogin,
  IVerifyResetCode_Request,
  IVerifyResetCode_Response,
} from "./account.model";
import { ApiService } from "../api/api.service";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AccountService {

  constructor(
    private apiService: ApiService,
    private sessionService: SessionService
  ) {}

  private readonly baseURL = environment.baseUrl;
  private readonly endpoint = "gossip/auth";
  public currentUserSource = new BehaviorSubject<IUserLogin | null>(
    this.getUserFromStorage()
  );
  public currentUser$ = this.currentUserSource.asObservable();

  private getUserFromStorage(): IUserLogin | null {
    try {
      const userString = localStorage.getItem("user");
      if (userString) {
        return JSON.parse(userString);
      }
    } catch (error) {
      console.error("Error parsing user from localStorage:", error);
      localStorage.removeItem("user");
    }
    return null;
  }

  login(model: ILoginUser_Request, rememberMe: boolean) {
    return this.apiService.post<ILoginUser_Request, ILoginApiResponse>({
      Url: `${this.endpoint}/login`,
      Body: model
    })
      .pipe(
        map(response => {
          if (response) {
            localStorage.setItem("user", JSON.stringify(response.data));
            this.currentUserSource.next({
              firstName: response.data.firstName,
              role: response.data.role,
              token: response.auth.token
            });
            if (response.auth && response.auth.token) {
              try {
                this.sessionService.setSession(
                  response.auth.token,
                  response.data,
                  rememberMe
                );
              } catch (err) {
                console.warn("Unable to set session via SessionService:", err);
              }
            }
          }
          return response;
        })
      );
  }

  forgot(model: IForgotPassword_Request) {
    return this.apiService.post<IForgotPassword_Request, IForgotPassword_Response>({
      Url: `${this.endpoint}/password/forgot-password`,
      Body: model
    });
  }

  verifyResetCode(req: IVerifyResetCode_Request) {
    return this.apiService.post<IVerifyResetCode_Request, IVerifyResetCode_Response>({
      Url: `${this.endpoint}/password/verify-reset-code`,
      Body: req
    });
  }

  resetPassword(req: IResetPassword_Request) {
    return this.apiService.post< IResetPassword_Request, IResetPassword_Response>({
      Url: `${this.endpoint}/password/reset-password`,
      Body: req
    });
  }

  onSubmitForm(model: IRegisterUser_Request) {
    return this.apiService
      .post< IRegisterUser_Request, IUserLogin>({
        Url: `${this.endpoint}/register`,
        Body: model
      })
      .pipe(
        map((response) => {
          if (response) {
            localStorage.setItem("user", JSON.stringify(response));
            this.currentUserSource.next({
              firstName: response.data.firstName,
              role: response.data.role,
              token: response.auth.token
            });
          }
          return response;
        })
      );
  }

  UpdateUser(user: IUserEntity) {
    return this.apiService.put<IUserEntity, IUserEntity>({
      Url: `account`,
      Body: user
    });
  }

  // loginUser(usernameOrEmail: string,password: string) {
  //   const loginRequest: ILoginUser_Request = {
  //     email: usernameOrEmail,
  //     password: password,
  //     loginType: "email",
  //   };

  //   return this.apiService
  //     .post<ILoginUser_Request, ILoginApiResponse>({
  //       Url: `${this.endpoint}/login`,
  //       Body: loginRequest
  //     })
  //     .pipe(
  //       map(response => {
  //         if (response && response.data && response.auth.token) {
  //           const role = response.data?.role || undefined;

  //           const userLogin: IUserLogin = {
  //             firstName: response.data?.firstName || usernameOrEmail,
  //             token: response.auth.token,
  //             role: role,
  //           };
  //           localStorage.setItem("user", JSON.stringify(userLogin));
  //           this.currentUserSource.next(userLogin);
  //           try {
  //             this.sessionService.setSession(
  //               response.auth.token,
  //               response.data || userLogin
  //             );
  //           } catch (err) {
  //             console.warn("Unable to set session via SessionService:", err);
  //           }
  //         }
  //         return response;
  //       })
  //     );
  // }

  setCurrentUser(user: IUserLogin) {
    this.currentUserSource.next(user);
  }

  logout() {
    localStorage.removeItem("user");
    this.currentUserSource.next(null);
  }

  changePassword(payload: IChangePasswordPayload) {
    return this.apiService.put<IChangePasswordPayload, IChangePasswordResponse>({
      Url: `${this.endpoint}/change-password`,
      Body: payload
    });
  }
}
